import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        list: '=',
        dashboard: '=',
        defaultFilter: '=',
        filter: '='
    },
    template: `
    <list-factory-empty list="vm.list" show-add-message="false"></list-factory-empty>
    <div class="well" ng-if="!vm.list.loading && vm.list.items.length">
        <table class="data01" datatable dt-options="vm.DATATABLES">
            <thead>
                <tr>
                    <th ng-class="vm.list.getSortClass('coursy_course_i18n.name')">
                        <a ng-click="vm.list.sortBy('coursy_course_i18n.name')">{{ 'planning.Course' | translate }}</a>
                    </th>
                    <th ng-class="vm.list.getSortClass('first_deadline_user_count')">
                        <a ng-click="vm.list.sortBy('first_deadline_user_count')">
                            {{ 'planning.Queued' | translate }}<br />
                            <span class="nobold">{{ 'planning.With first deadline' | translate }} <small>{{ 'planning.(within 3 months)' | translate }}</small></span>
                        </a>
                    </th>
                    <th ng-class="vm.list.getSortClass('without_deadline_user_count')">
                        <a ng-click="vm.list.sortBy('without_deadline_user_count')">{{ 'planning.Without personal deadline' | translate }}</a>
                    </th>
                    <th ng-class="vm.list.getSortClass('first_deadline')">
                        <a ng-click="vm.list.sortBy('first_deadline')">{{ 'planning.First deadline' | translate }}</a>
                    </th>
                    <th >&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr ng-class="{ status01: vm.isDeadlineClose(item.firstDeadline) && !vm.filter.hideCachedData }" ng-repeat="item in vm.list.items">
                    <td>
                        <a ng-if="vm.TokenService.isCompanyMagnum()"
                        ui-sref="authorized.courses.courses.edit.general({id: item.courseId})"
                        >{{ item.course.sop }} {{ item.courseActiveI18n.name }}</a>
                        <a ng-if="!vm.TokenService.isCompanyMagnum()"
                        ui-sref="authorized.courses.courses.edit.general({id: item.courseId})"
                        >{{ item.courseActiveI18n.name }}</a>
                        <span ng-if="item.planningGroups.length" class="badge" uib-tooltip="{{ vm.automatedToolTip }}">A</span>
                    </td>
                    <td ng-if="vm.filter.hideCachedData">0 <small>(0)</small></td>
                    <td ng-if="!vm.filter.includeApgEmployees && !vm.filter.hideCachedData">{{ item.firstDeadlineUserCount }} <small>({{ item.planningNeed3MonthUserCount }})</small></td>
                    <td ng-if="vm.filter.includeApgEmployees && !vm.filter.hideCachedData">{{ item.firstDeadlineUserCountApg }} <small>({{ item.planningNeed3MonthUserCountApg }})</small></td>
                    <td>{{ item.withoutDeadlineUserCount }}</td>
                    <td>
                        <a ng-if="!vm.filter.includeApgEmployees"" ng-click="vm.setDeadline(item)">
                            <span ng-if="item.firstDeadline && !vm.filter.hideCachedData">{{ vm.MomentService.formatDate(item.firstDeadline) }}</span>
                            <span ng-if="!vm.dashboard && (!item.firstDeadline || vm.filter.hideCachedData)">{{ 'planning.Add deadline' | translate  }}</span>
                            <span ng-if="vm.dashboard && (!item.firstDeadline || vm.filter.hideCachedData)">{{ 'general.Add' | translate  }}</span>
                        </a>
                        <a ng-if="vm.filter.includeApgEmployees"" ng-click="vm.setDeadline(item)">
                            <span ng-if="item.firstDeadlineApg && !vm.filter.hideCachedData">{{ vm.MomentService.formatDate(item.firstDeadlineApg) }}</span>
                            <span ng-if="!vm.dashboard && (!item.firstDeadlineApg || vm.filter.hideCachedData)">{{ 'planning.Add deadline' | translate  }}</span>
                            <span ng-if="vm.dashboard && (!item.firstDeadlineApg || vm.filter.hideCachedData)">{{ 'general.Add' | translate  }}</span>
                        </a>
                    </td>
                    <td class="actions">
                        <a class="btn ico-calendar" ui-sref="authorized.courses.courses.edit.occurrence.list({id: item.courseId})"
                        >{{ 'planning.Plan' | translate }}</a>
                    </td>
                </tr>
            </tbody>
        </table>
        <pagination list="vm.list"></pagination>
    </div>
    `
})
export default class {
    constructor ($translate, moment, DATATABLES, ModalService, TokenService, MomentService) {
        this.$translate = $translate;
        this.moment = moment;
        this.DATATABLES = DATATABLES;
        this.ModalService = ModalService;
        this.MomentService = MomentService;
        this.TokenService = TokenService;
        this.twoWeeksNoticeDate = moment().add(14, 'days');
    }

    $onInit () {
        this.automatedToolTip = this.$translate.instant('planning.Has automated planning group');
    }

    isDeadlineClose (date) {
        // if twoWeeksNoticeDate is after deadline date, return true
        return date ? this.moment(this.twoWeeksNoticeDate).isAfter(date) : false;
    }

    setDeadline (trainingNeed) {
        const filter = angular.copy(this.filter);
        this.ModalService.open({
            size: 'xlarge',
            template: `
                <modals-planning-needs-deadline class="wrapper"
                    ok="vm.$uibModalInstance.close()"
                    cancel="vm.$uibModalInstance.dismiss()"
                    course-id="vm.trainingNeed.courseId"
                    filter="vm.filter"
                />
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.trainingNeed = trainingNeed;
                this.filter = filter;
            }
        })
        .then(() => {
            this.list.fetch(this.filter);
        });
    }
}




// WEBPACK FOOTER //
// ./src/app/components/planning/needs/list/index.js